<template>
  <app-base-main no-padding :contentStyle="{ height: '100%' }">
    <template #base-content>
      <div class="rule-content">
        <guide :guideData="guideData" ref="guideRef"></guide>
        <div class="rule-main guide-rule-main">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width="90px"
            class="demo-ruleForm"
          >
            <gj-area-title>基础信息</gj-area-title>
            <!-- base-info内部的元素排列顺序会有变化  -->
            <div class="base-info">
              <div
                class="flex_50"
                :style="baseInfo['name']"
                v-if="!computeTemplate"
              >
                <el-form-item
                  class="name-input"
                  label="规则名称"
                  prop="name"
                  :rules="[
                    {
                      required: true,
                      message: '请输入模板名称',
                      trigger: 'blur',
                    },
                    {
                      min: 1,
                      max: 60,
                      message: '长度不超过60个字符',
                      trigger: 'blur',
                    },
                    verifyName,
                  ]"
                >
                  <gj-input
                    v-model="ruleForm.name"
                    style="width: 80%"
                    maxlength="60"
                    show-word-limit
                    placeholder="请输入名称"
                  >
                  </gj-input>
                </el-form-item>
              </div>
              <div class="flex_50" :style="baseInfo['inform']">
                <el-form-item
                  label="结果通知"
                  :prop="ruleForm.notifyType !== 'no' ? 'notifyType' : ''"
                  class="flex_2"
                >
                  <template #label>
                    <span style="margin-right: 2px">结果通知</span>
                    <gj-help class="gj-help">
                      <div>
                        自动规则执行完成后，会通过站内消息、微信公众号通知您执行的结果。
                      </div>
                      <div>- 不通知：每次执行完成后都不会通知到您；</div>
                      <div>- 执行完成通知：每次执行完都将通知您；</div>
                      <div>
                        - 有错误时通知：当有自动规则执行失败的情况下才通知您。
                      </div>
                    </gj-help>
                  </template>
                  <div style="display: flex">
                    <gj-select
                      :disabled="!!computeTemplate"
                      v-model="ruleForm.notifyType"
                      :options="option.notifyTypeOption"
                      :clearable="false"
                      width="156px"
                    >
                    </gj-select>
                    <el-form-item
                      class="error-excursion"
                      v-if="ruleForm.notifyType !== 'no'"
                      prop="notifyUser"
                      :rules="{ required: true, message: '请选择通知人', trigger: 'change' },"
                    >
                      <gj-creator-select
                        :disabled="!!computeTemplate"
                        ref="creatorSelectRef"
                        style="margin-left: 10px; width: 156px"
                        v-model="ruleForm.notifyUser"
                        placeholder="请选择通知人"
                        :type="'multi-check'"
                      >
                      </gj-creator-select>
                    </el-form-item>
                  </div>
                </el-form-item>
              </div>
              <!-- <div class="flex_50" :style="baseInfo['type']">
                <el-form-item class="flex_2" label="广告类型">
                  <span>商品广告</span>
                </el-form-item>
              </div> -->
              <div
                class="flex_50"
                v-if="$route.query.belong === 'rule'"
                :style="baseInfo['object']"
              >
                <el-form-item class="flex_2" label="应用对象">
                  <span style="margin-right: 8px">{{
                    extra.applyObjectName
                  }}</span>
                  <el-tag size="mini" type="info">{{
                    objectAdsType[extra.applyObjectAdsType]
                  }}</el-tag>
                </el-form-item>
              </div>
              <div
                class="flex_50"
                v-if="$route.query.belong === 'rule'"
                :style="baseInfo['template']"
              >
                <el-form-item class="flex_2" label="内容模板">
                  <gj-select
                    v-model="template"
                    :options="templateOption"
                    :clearable="false"
                    width="160px"
                    @change="handleTemplate"
                  >
                  </gj-select>
                </el-form-item>
              </div>
            </div>
            <gj-area-title style="margin-top: 12px">规则设置</gj-area-title>

            <div class="rule-setting">
              <div>
                <div class="alert-content">
                  <gj-alert type="info" show-icon>
                    <template #title>
                      <div>规则预览：{{ rule }}</div>
                    </template>
                  </gj-alert>
                </div>
                <div
                  v-if="template && templateType === 'template'"
                  style="margin-bottom: 20px; padding-left: 40px"
                >
                  部分自动规则需优化，需要<span
                    style="color: #1f6eef; cursor: pointer"
                    @click="handleSingle"
                    >单独调整</span
                  >
                  ，调整后自动规则只对当前的应用生效，不影响模板;
                </div>
                <el-form-item
                  label="优化对象"
                  prop="expressionDTO.executeObjectAdsType"
                  :rules="{
                    required: true,
                    message: '请选择优化对象',
                    trigger: 'change',
                  }"
                >
                  <gj-select
                    :disabled="
                      !!computeTemplate || $route.query.type === 'edit'
                    "
                    v-model="ruleForm.expressionDTO.executeObjectAdsType"
                    :options="
                      option.executeObjectAdsTypeeOption[ruleForm.adsType]
                    "
                    :clearable="false"
                    width="138px"
                  >
                  </gj-select>
                </el-form-item>
                <div style="display: flex">
                  <el-form-item
                    label="数据范围"
                    prop="expressionDTO.includeDay"
                    class="error-input31"
                    :rules="{
                      required: true,
                      message: '请选择数据范围',
                      trigger: 'change',
                    }"
                  >
                    <span style="margin-right: 8px">过去</span>
                    <gj-select
                      :disabled="!!computeTemplate"
                      v-model="ruleForm.expressionDTO.includeDay"
                      :options="option.includeDayOption"
                      :clearable="false"
                      width="64px"
                      placeholder=""
                    >
                    </gj-select>
                    <span style="margin-left: 8px; margin-right: 22px">天</span>
                  </el-form-item>
                  <div style="display: flex; align-items: center; height: 32px">
                    <gj-checkbox v-model="isExclude"></gj-checkbox>
                    <span style="margin: 0 8px">排除近</span>
                    <gj-select
                      :disabled="!!computeTemplate"
                      v-model="ruleForm.expressionDTO.excludeDay"
                      :options="option.excludeDayOption"
                      :clearable="false"
                      width="64px"
                      placeholder=""
                    >
                    </gj-select>
                    <span style="margin: 0 4px 0 8px">天</span>
                    <gj-help class="gj-help">
                      建议排除近3天数据，亚马逊近3天数据变化较大
                    </gj-help>
                    <span
                      style="margin-left: 20px; color: #828282"
                      v-if="dataField"
                    >
                      <i
                        class="el-icon-warning-outline"
                        style="font-size: 13px"
                      ></i>
                      {{ dataField }}
                    </span>
                  </div>
                </div>

                <el-form-item
                  label="执行条件"
                  prop="expressionDTO.expressionList"
                  :rules="{
                    required: true,
                    message: '请选择优化对象',
                    trigger: 'change',
                  }"
                >
                  <div class="condition-bg">
                    <div
                      class="condition"
                      v-for="(item, index) in ruleForm.expressionDTO
                        .expressionList"
                      :key="index"
                    >
                      <div class="rule-text-bg">
                        <div class="rule-text" v-if="index !== 0">且</div>
                      </div>
                      <div style="display: flex; flex: 1">
                        <el-form-item
                          class="margin12"
                          :prop="`expressionDTO.expressionList[${index}].metric`"
                          :rules="selectVerify"
                        >
                          <gj-select
                            :disabled="!!computeTemplate"
                            v-model="item.metric"
                            :options="option.metricOption"
                            :clearable="false"
                            width="180px"
                          >
                          </gj-select>
                        </el-form-item>
                        <el-form-item
                          v-if="exclude.indexOf(item.metric) < 0"
                          class="margin12"
                          :prop="`expressionDTO.expressionList[${index}].calculateType`"
                          :rules="selectVerify"
                        >
                          <gj-select
                            :disabled="!!computeTemplate"
                            v-model="item.calculateType"
                            :options="option.calculateTypeOption"
                            :clearable="false"
                            width="180px"
                          >
                          </gj-select>
                        </el-form-item>
                        <el-form-item
                          class="margin12"
                          :prop="`expressionDTO.expressionList[${index}].exp`"
                          :rules="selectVerify"
                        >
                          <gj-select
                            :disabled="!!computeTemplate"
                            v-model="item.exp"
                            :options="option.expOption"
                            :clearable="false"
                            width="180px"
                          >
                          </gj-select>
                        </el-form-item>
                        <el-form-item
                          class="margin12"
                          :prop="`expressionDTO.expressionList[${index}].value`"
                          :rules="[
                            item.metric
                              ? verifyCondition[item.metric]
                              : inputVerify,
                          ]"
                        >
                          <gj-input
                            :disabled="!!computeTemplate"
                            style="width: 180px"
                            class="margin12"
                            v-model="item.value"
                          >
                            <template
                              slot="append"
                              v-if="percent.indexOf(item.metric) > -1"
                              >%</template
                            >
                          </gj-input>
                        </el-form-item>
                      </div>
                      <div class="rule-icons">
                        <el-button
                          @click="addCondition(item, index)"
                          icon="el-icon-circle-plus-outline"
                          class="rule-icon"
                          :disabled="
                            !(
                              !computeTemplate &&
                              ruleForm.expressionDTO.expressionList.length !== 5
                            )
                          "
                          circle
                        ></el-button>
                        <el-button
                          :disabled="!!computeTemplate"
                          icon="el-icon-remove-outline"
                          @click="deleteCondition(item, index)"
                          v-if="
                            ruleForm.expressionDTO.expressionList.length > 1
                          "
                          class="rule-icon"
                          circle
                        ></el-button>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <!-- 执行操作 -->
                <el-form-item label="执行操作" :rules="selectVerify">
                  <div class="handle-content" v-if="initialize">
                    <el-form-item
                      v-for="(item, index) in selectConfig"
                      :key="index"
                      :rules="item.verify"
                      class="handle-item"
                      :class="item.class"
                      :prop="`expressionDTO.${item.model}`"
                    >
                      <span v-if="item.label" style="margin: 0 12px">{{
                        item.label
                      }}</span>
                      <component
                        :disabled="
                          !!computeTemplate ||
                          (item.editDisable && $route.query.type === 'edit')
                        "
                        :is="item.element"
                        v-model="ruleForm.expressionDTO[item.model]"
                        :initValue="ruleForm.expressionDTO[item.model]"
                        :options="item.option"
                        :clearable="item.clearable"
                        :width="item.width"
                        :filterable="item.filterable"
                        :placeholder="item.placeholder"
                        @change="handleChange($event, item, index)"
                        :notInit="notInit"
                      >
                        <template slot="append" v-if="item.slot">%</template>
                      </component>
                      <span v-if="item.later" style="margin: 0 12px">{{
                        item.later
                      }}</span>
                      <span
                        v-if="
                          item.laterBind &&
                          ruleForm.expressionDTO[item.model] ===
                            item.laterBind.key
                        "
                        style="margin: 0 12px"
                        >{{ item.laterBind.label }}</span
                      >
                    </el-form-item>
                  </div>
                  <div style="padding-top: 12px" v-show="writerText">
                    {{ writerText }}
                  </div>
                </el-form-item>
                <el-form-item
                  prop="expressionDTO.executeInterval"
                  class="flex_2 error-input18"
                  :rules="[
                    inputVerify,
                    verifyList.frequencyc,
                    { required: true, message: '请输入', trigger: 'change' },
                  ]"
                >
                  <template #label>
                    <span style="margin-right: 2px">执行频率</span>
                    <gj-help class="gj-help">
                      每次执行时间为站点时间：早上6:30点
                    </gj-help>
                  </template>
                  <span class="autocomplete-input">
                    <span style="margin: 0 8px 0 0">每</span>
                    <el-autocomplete
                      :disabled="!!computeTemplate"
                      class="inline-input"
                      popper-class="ad-autocomplete-input"
                      v-model="ruleForm.expressionDTO.executeInterval"
                      style="width: 70px"
                      value="id"
                      :max="60"
                      :min="1"
                      value-key="text"
                      :fetch-suggestions="querySearch"
                      placeholder="请输入"
                    ></el-autocomplete>
                    <span style="margin-left: 8px">天</span>
                  </span>
                </el-form-item>
              </div>
              <div class="rule-description">
                <div
                  style="
                    display: flex;
                    align-items: center;
                    padding: 10px;
                    height: 20px;
                  "
                >
                  <img
                    src="@/assets/images/rule-text.svg"
                    style="margin-right: 8px"
                  />
                  <span style="font-weight: bold">规则说明</span>
                </div>
                <div class="rule-description-text">
                  <div class="margintop20">
                    1、当多个不同操作同时满足条件时，仅执行高优先级的自动规则，优先级排序：“暂停”>“添加到否定投放”>“添加投放”>“调整预算/调整竞价”；
                  </div>
                  <div class="margintop20">
                    2、当多个相同操作（如调整竞价）同时满足条件时，只执行最近添加的规则；
                  </div>
                  <div class="margintop20">
                    3、调整预算/竞价：自动规则调整时会以最后手动修改的预算/竞价作为原始预算/竞价，且调整后后续不会自动恢复为原始预算/竞价；
                  </div>
                  <div class="margintop20">
                    4、预算/竞价的调整，如需根据业绩表现分别设置上浮和下调的规则，需为同一优化对象设置两个自动规则；
                  </div>
                  <div class="margintop20">
                    5、同一对象，同时设置了分时策略和自动规则的调价，分时价格不会作为自动规则的调价基础，但自动规则调价的结果会作为下个时段分时调价的原始价。
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="rule-footer">
          <gj-button type="primary" plain @click="handleCancel(null)"
            >取消</gj-button
          >
          <gj-button
            type="primary"
            plain
            v-if="$route.query.belong === 'rule' && !computeTemplate"
            @click="handleObject('template')"
            >应用并存为模板</gj-button
          >
          <gj-button
            type="primary"
            v-if="$route.query.belong === 'rule'"
            @click="handleObject('rule')"
            >应用</gj-button
          >
          <gj-button
            type="primary"
            @click="handleSave"
            v-if="$route.query.belong === 'template'"
            >保存</gj-button
          >
        </div>
      </div>
    </template>
  </app-base-main>
</template>

<script>
/**
 * 路由参数解释
 * type: 'add | edit'  表示新增数据还是编辑数据
 * belong: 'template | rule'  template表示是从自动规则入口增加规则或模板，rule表示和应用绑定的数据
 * sourceRoute: this.$route.path, 表示从那个入口进到页面，用于回退
 * extra: JSON.stringify(extra) 额外的参数
 */
import {
  option,
  selectMap,
  writerAdjustBase,
  ruleMap,
  ruleText,
  baseInfoOrder,
  objectAdsType,
  verifyCondition,
  verifyList,
  guideData,
} from "./config";
import SelectAdAotu from "./select-ad-aotu.vue";
import {
  addRuleTemplate,
  queryTemplate,
  batchRule,
  editBatchTemplate,
  templateSelect,
  autoRuleObjectData,
  querySameRule,
  queryCheckName,
  getSpAdSuggestKeywordForAsinList,
} from "@/api/ad";
import _ from "lodash";
import affirmModal from "./affirm-modal.vue";
import { getRuleContent } from "../const";
import guide from "../guide.vue";
import { getAllMap } from "@/api/dashboard";

// 初始化查询参数
const initParams = () => {
  return {
    name: null, // 模板名称
    notifyType: "error", // 通知类型
    notifyUser: [], // 通知人， 通知类型非 no 时必填
    adsType: "sp", // 第一版只有商品广告
    state: "enabled", //状态默认开启
    type: "template", //类型（rule：规则，template：模板）默认新增入口是模板，也有规则新增入口
    expressionDTO: {
      executeObjectAdsType: "campaign", //优化对象
      includeDay: 7, // 过去多少天
      excludeDay: 3, // 排除的天数
      executeInterval: null, // 执行频率
      expressionList: [
        {
          metric: null, //指标
          calculateType: null, //计算类型
          exp: null, //符号
          value: null, //指标值
        },
      ],
      strategyType: null, //执行的操作类型
      adjustBase: null, //调价基础
      adjustType: null, //调价类型
      adjustValue: null, //调价值
      adjustLimitValue: null, //调价极限值
      matchType: null, //匹配类型（关键词/否定关键词特定）
      targetMarketId: null, // 添加投放站点id
      targetCampaignId: null, // 添加投放广告活动id
      targetGroupId: null, // 添加投放的广告组id
    },
  };
};
export default {
  name: "add-rule-template",
  components: {
    SelectAdAotu,
    guide,
  },
  inject: ["removeTab", "getNavTabs"],
  data() {
    return {
      guideData,
      option,
      selectMap,
      objectAdsType,
      verifyCondition,
      verifyList,
      exclude: ["ctr", "cpc", "cvr", "cpa", "acos", "roas"], // 不需要平均值选项的数据d
      percent: ["ctr", "cvr", "acos", "roas"], //输入框需要百分号单位的
      ruleForm: initParams(),
      // 该字段用于回显
      echo: {
        executeObjectAdsType: null, //优化对象
        strategyType: null, //执行的操作类型
        adjustBase: null, //调价基础
        adjustType: null, //调价类型
        adjustValue: null, //调价值
        adjustLimitValue: null, //调价极限值
        matchType: null, //匹配类型（关键词/否定关键词特定）
        targetMarketId: null, // 添加投放站点id
        targetCampaignId: null, // 添加投放广告活动id
        targetGroupId: null, // 添加投放的广告组id
      },
      isExclude: true, // 是否需要排除天数
      inputVerify: {
        // 通用校验
        required: true,
        message: "请输入",
        trigger: "blur",
      },
      selectVerify: {
        // 通用校验
        required: true,
        message: "请选择",
        trigger: "change",
      },
      selectConfig: [],
      sourceRoute: "", //来源路由 用于取消时的回退
      notInit: true,
      previewVal: {},
      template: this.$route.query.id,
      templateType: this.$route.query.templateDetailVOType, //是否选择模板
      extraTemplate: this.$route.query.id,
      templateOption: [], // 模板列表选项
      extra: {}, // 路由带进来的额外参数
      fields: [
        "strategyType", //执行的操作类型
        "adjustBase", //调价基础
        "adjustType", //调价类型
        "adjustValue", //调价值
        "adjustLimitValue", //调价极限值
        "matchType", //匹配类型（关键词/否定关键词特定）
        "targetMarketId", // 添加投放站点id
        "targetCampaignId", // 添加投放广告活动id
        "targetGroupId", // 添加投放的广告组id
      ],
      verifyName: {
        validator: (rule, value, callback) => {
          queryCheckName({ name: value, id: this.$route.query.id || "" }).then(
            (data) => {
              if (data) {
                callback(new Error("规则名称已经存在！"));
              } else {
                callback();
              }
            }
          );
        },
        trigger: "blur",
      },
      initialize: true, //切换模板时初始化状态会执行异常，需要用此字段控制
      campaignOption: [], //广告活动选项
      groupOption: [], // 广告组选项
    };
  },
  computed: {
    computeTemplate() {
      return this.templateType === "template";
    },
    // 数据范围
    dataField() {
      if (this.ruleForm.expressionDTO.includeDay === null) {
        return false;
      }
      return this.isExclude
        ? `排除近${this.ruleForm.expressionDTO.excludeDay}天，数据范围实际指第${
            this.ruleForm.expressionDTO.excludeDay + 1
          }-${
            this.ruleForm.expressionDTO.includeDay +
            this.ruleForm.expressionDTO.excludeDay
          }天的数据`
        : `数据范围为前${this.ruleForm.expressionDTO.includeDay}天的数据`;
    },
    writerText() {
      const { data, getText } = writerAdjustBase();
      let text = data[this.ruleForm.expressionDTO.executeObjectAdsType];
      return getText(text && text[this.ruleForm.expressionDTO.adjustBase]);
    },
    targetCampaignName() {
      return this.campaignOption.filter(
        (item) => item.id === this.ruleForm.expressionDTO.targetCampaignId
      )[0]?.campaignName;
    },
    targetGroupName() {
      return this.groupOption.filter(
        (item) => item.id === this.ruleForm.expressionDTO.targetGroupId
      )[0]?.groupName;
    },
    rule() {
      return getRuleContent(
        {
          ...this.ruleForm.expressionDTO,
          targetCampaignName: this.targetCampaignName,
          targetGroupName: this.targetGroupName,
        },
        this.isExclude
      );
    },
    baseInfo() {
      return baseInfoOrder[this.$route.query.belong] || {};
    },
  },
  watch: {
    // 第一层
    "ruleForm.expressionDTO.executeObjectAdsType"(nVal) {
      this.initSelect(nVal);
    },
  },
  async mounted() {
    getAllMap().then((res) => {
      if (!res.adAutoRuleCreate) {
        // this.$refs.guideRef.start();
      }
    });
    if (this.$route.query.sourceRoute) {
      this.sourceRoute = this.$route.query.sourceRoute;
    }

    if (this.$route.query.extra) {
      this.extra = JSON.parse(this.$route.query.extra)[0];
    }

    if (this.$route.query.belong === "rule") {
      // 额外参数
      this.queryTemplateSelect();
    }

    // 编辑模式下数据回显
    if (
      this.$route.query.type === "edit" ||
      this.$route.query.type === "copy"
    ) {
      await this.queryEchoData();
    } else {
      this.initHanle();
    }
  },

  methods: {
    // 回显方法
    async queryEchoData(id = this.$route.query.id, key = "expressionVO") {
      // 不选择模板则id为null
      if (id) {
        const data = await queryTemplate(id);
        data.expressionDTO = data[key];
        delete data[key];
        // 由于某些组件只支持string类型，需要处理一下
        data.expressionDTO.executeInterval =
          data.expressionDTO.executeInterval.toString();
        // 拷贝数据并赋值
        this.ruleForm = _.cloneDeep(data);
        // 由于回显需要，需要对以下字段处理
        this.echo.executeObjectAdsType =
          data.expressionDTO.executeObjectAdsType; // 单独处理
        this.fields.forEach((item) => {
          this.echo[item] = data.expressionDTO[item]; // PS:其他来源的数据expressionDTO名称可能不一致
          this.ruleForm.expressionDTO[item] = null;
        });
        // 复制处理
        if (this.$route.query.type === "copy") {
          this.ruleForm.name = `${this.ruleForm.name}-复制`;
        }
        // 单独处理数据范围的勾选 ps:此处并不能覆盖所有的回显场景
        this.isExclude = !!this.ruleForm.expressionDTO.excludeDay;
        this.initHanle();
      } else {
        // 初始化数据
        // this.initSelect();
        Object.assign(this.ruleForm, initParams());
        this.notInit = false;
      }
    },

    // 初始化执行操作部分
    initHanle() {
      // 初始化第一层
      this.initSelect();
      // 数据回显需要做的一些处理
      this.ruleForm.notifyUser = this.ruleForm.notifyUser.map(
        (item) => item.id
      );
      // 递归回显数据
      if (this.echo.executeObjectAdsType) {
        this.notInit = true;
        // 将回显数据中的type回显，不直接写入ruleForm里面是因为需要用这个字段来判断是否需要回显
        this.ruleForm.expressionDTO.executeObjectAdsType =
          this.echo.executeObjectAdsType;
        // 调用递归方法
        this.initialize = true;
        this.echoRecursion();
      } else {
        // 如果不是回显，则将初始化change事件关闭
        this.notInit = false;
      }
    },
    // 获取参数并进行校验
    async getParams() {
      let params = null;
      await this.$refs.ruleForm.validate().then((res) => {
        if (res) {
          params = _.cloneDeep(this.ruleForm);
          // 处理自动规则
          if (!this.isExclude) {
            params.expressionDTO.excludeDay = null;
          }
          // 处理通知人
          if (this.ruleForm.notifyType !== "no") {
            const notifyUserMap = this.$refs.creatorSelectRef.getOptions();
            params.notifyUser = params.notifyUser.map((item) => {
              return {
                id: item,
                name: notifyUserMap.filter((el) => el.id === item)[0].text,
              };
            });
          }
          // 需要对执行条件进行处理
          params.expressionDTO.expressionList.forEach((item) => {
            if (this.exclude.indexOf(item.metric) > -1) {
              delete item.calculateType;
            }
          });
        }
      });
      return params;
    },
    // 保存
    async handleSave() {
      const params = await this.getParams();

      // 新增模板
      if (
        (this.$route.query.type === "add" ||
          this.$route.query.type === "copy") &&
        params
      ) {
        if (this.$route.query.type === "copy") {
          delete params.id;
        }
        addRuleTemplate([params]).then((res) => {
          this.$message.success("新增成功！");
          this.handleCancel("2");
        });
      }
      // 编辑模板
      if (this.$route.query.type === "edit" && params) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: "提示",
            content: `模板编辑后，所有应用该自动化的广告都会按照新模板执行，请确认是否提交？`,
          },
          on: {
            cancel: () => {
              modal.$gjDestroy();
            },
            confirm: () => {
              editBatchTemplate([params]).then((res) => {
                this.$message.success(res.msg);
                modal.$gjDestroy();
                this.handleCancel("2");
              });
            },
          },
        });
      }
    },
    // 天数输入建议
    querySearch(queryString, cb) {
      let restaurants = this.option.executeIntervalOption;
      let results = queryString
        ? restaurants.filter((item) => item.text === queryString)
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    // 初始化执行操作 第一层数据
    initSelect(val) {
      if (this.selectConfig.length > 0) {
        this.selectConfig = [];
        // 清空数据中存在的值
        this.fields.forEach((item) => {
          this.ruleForm.expressionDTO[item] = null;
        });
      }
      const { config } = this.selectMap();
      this.selectConfig.push(
        config[val ?? this.ruleForm.expressionDTO.executeObjectAdsType][0]
          .select
      );
    },
    // 添加执行条件
    addCondition(item, index) {
      this.ruleForm.expressionDTO.expressionList.push({
        metric: "", //指标
        calculateType: "", //计算类型
        exp: "", //符号
        value: "", //指标值
      });
    },
    // 删除执行条件
    deleteCondition(item, index) {
      this.ruleForm.expressionDTO.expressionList.splice(index, 1);
    },

    // 操作选项
    async handleChange(e, item, index) {
      let source = "change";
      if (e?.initValue) {
        source = "initValue"; // 触发来源是回显初始化
        e = e.initValue;
      }

      // console.log(e, '选项');
      // console.log(item);
      // console.log(index);

      // 将部分字段的text存到data中，预览时需要
      this.previewValMap(e, item);

      // 只处理下拉框的change事件，且input都在最后一步
      if (item.element === "select-ad-aotu") {
        const { config } = this.selectMap();
        const { getNext, getData } = this.selectMap();
        const next = getNext(item.option, e);
        // 新增数据逻辑
        const addData = () => {
          next.forEach((element) => {
            const data = getData(item, index, element);
            if (data) {
              this.selectConfig.push(data);
              // 表示这条数据被添加过
              data.flag = true;
            }
          });
        };

        // 处理异步选项 ps：不处理来自回显异步
        if (source === "change") {
          // 选中的next
          const optionItem = item.option.filter((el) => el.id === e)[0];
          if (
            item.nextOptionFn &&
            optionItem.next.length &&
            !optionItem?.notOptionFn
          ) {
            config[item.belong][index + 1][next[0]].option =
              await item.nextOptionFn(e, item);
            // 部分步骤需要保存选项数据
            if (item.saveOption) {
              this[item.saveOption] =
                config[item.belong][index + 1][next[0]].option;
            }
          }
        }

        if (
          !(this.selectConfig.length === index + 1) ||
          index + 2 < this.selectConfig.length
        ) {
          console.log("需要删除后面的选项");
          // 选项清空处理
          config[this.ruleForm.expressionDTO.executeObjectAdsType].forEach(
            (el, elIndex) => {
              // 只处理选项以上层级的数据
              if (elIndex > index) {
                for (let key in el) {
                  if (el[key].flag) {
                    this.ruleForm.expressionDTO[el[key].model] = null;
                    el[key].flag = false;
                  }
                }
              }
            }
          );
          this.selectConfig.splice(index + 1, this.selectConfig.length - index);
        }
        addData();
      }
    },

    // 回显递归 从 0 开始
    async echoRecursion(index = 0, key = "strategyType", widget = ["select"]) {
      const { config } = this.selectMap();
      // 当前优化对象
      const adsType = this.ruleForm.expressionDTO.executeObjectAdsType;
      // 获取对应 index 层的数据 注意 widget 是数组，一般情况下一层有多个组件的都是最后一层
      const data = widget.map((item) => {
        return config[adsType][index][item];
      });
      // 拿到data数据中每一层选中的数据
      const option = data.map((item) => {
        return item.option.filter((item) => item.id === this.echo[key])[0];
      });
      // 处理异步选项
      for (let fIndex = 0; fIndex < data.length; fIndex++) {
        const el = data[fIndex];
        if (el.nextOptionFn && !option[0]?.notOptionFn) {
          // option.notOptionFn 表示不执行方法
          config[adsType][index + 1][option[fIndex].next[0]].option =
            await el.nextOptionFn(this.echo[key], el);
          // 部分步骤需要保存选项数据
          if (el.saveOption) {
            this[el.saveOption] =
              config[adsType][index + 1][option[fIndex].next[0]].option;
          }
        }
      }

      // todo 可以将这部分优化处理到上面的for循环中
      if (data.length > 1) {
        data.forEach((item) => {
          if (item.option.length === 0) {
            // 当option为空是表示没有数据了 一般情况下一层有多个组件的都是最后一层
            this.$nextTick(() => {
              this.ruleForm.expressionDTO[item.model] = this.echo[item.model];
            });
          } else {
            console.log("还有下一层");
          }
        });
      } else {
        this.$nextTick(() => {
          this.ruleForm.expressionDTO[key] = this.echo[key];
          if (option[0]?.next.length > 0) {
            // 下一层显示的组件数组
            const nextWidget = option[0].next;
            // 下一层的key
            const nextKey = config[adsType][index + 1][nextWidget[0]].model;
            this.echoRecursion(index + 1, nextKey, nextWidget);
          }
        });
      }
    },

    // 预览部分字段处理方法
    previewValMap(val, item) {
      const keys = ["targetMarketId", "targetCampaignId", "targetGroupId"];
      if (keys.indexOf(item.model) > -1) {
        this.$set(
          this.previewVal,
          item.model,
          item.option.filter((el) => el.id === val)[0].text
        );
      }
    },

    // 预览规则 id 转 text
    getRuleVal(arr, val) {
      // ruleMap
      return arr.filter((item) => item.id === val)[0]?.text || "**";
    },

    /**
     * 取消
     * tabKey 判断那个tab需要刷新列表
     * refresh 传入Refresh表示所有列表都需要刷新
     * isSource 当不需要回退到来源路由时可传入
     */
    handleCancel(tabKey = null, refresh = "", isSource = true) {
      const name =
        this.$route.query.type === "edit" ? "编辑自动规则" : "新增自动模板规则";
      if (this.sourceRoute && isSource) {
        this.$router.push({
          path: this.sourceRoute,
          query: { refresh, tabKey },
        });
      }
      this.removeTab(name);
    },

    // 查询模板下拉数据
    queryTemplateSelect() {
      const extra = this.extra;
      const params = {
        adsType: "sp",
        campaignId: extra.campaignId,
        executeObjectAdsType: extra.applyObjectAdsType,
        marketId: extra.marketId,
        objectId: extra.applyObjectId,
        templateId: this.$route.query.id,
      };
      templateSelect(params).then((res) => {
        res.forEach((item) => {
          item.text = item.name;
        });
        this.templateOption = res;
      });
    },

    // 切换模板
    handleTemplate() {
      // 当从模板切换到不使用模板需要回显

      // 通过v-if的切换让下拉框回到初始状态, 才能让执行操作正确回显 在有模板ID的时候才需要这样做，编辑状态下 不使用模板也是有ID的
      if (
        this.template ||
        (this.$route.query.type === "edit" &&
          this.$route.query.belong === "rule" &&
          !this.template)
      ) {
        this.initialize = false;
      }

      // ****************** 当从模板切换到非模板时 需要保留 对象 操作类型 站点
      let executeObjectAdsType = null;
      let strategyType = null;
      let targetMarketId = null;
      if (this.$route.query.type === "edit" && !this.template) {
        executeObjectAdsType = this.ruleForm.expressionDTO.executeObjectAdsType;
        strategyType = this.ruleForm.expressionDTO.strategyType;
        targetMarketId = this.ruleForm.expressionDTO.targetMarketId;
      }
      // ****************** 当从模板切换到非模板时 需要保留 对象 操作类型 站点

      // 选择时 如果选中的内容type为模板则禁用所有
      this.templateType = this.templateOption.filter(
        (item) => item.id === this.template
      )[0].type;
      this.queryEchoData(this.template).then(() => {
        // ****************** 当从模板切换到非模板时 需要保留 对象 操作类型 站点
        if (this.$route.query.type === "edit" && !this.template) {
          // 清空回显的暂时存值对象
          this.fields.forEach((item) => {
            this.echo[item] = null;
          });
          // 允许初始化
          this.notInit = true;
          // 对三个保留字段进行初始化
          this.echo.executeObjectAdsType = executeObjectAdsType;
          this.echo.strategyType = strategyType;
          this.echo.targetMarketId = targetMarketId;
          // 执行递归前需要将执行操作对象回显
          this.initHanle();
        }
        // ****************** 当从模板切换到非模板时 需要保留 对象 操作类型 站点
      });
    },

    // 保存
    async handleObject(type) {
      // 校验是否通过
      const templateCreateDTO = await this.getParams();
      if (!templateCreateDTO) {
        return;
      }
      // 模板转规则时的执行条件
      if (type === "template") {
        templateCreateDTO.type = type;
      } else if (this.templateType === "rule" && !this.template) {
        templateCreateDTO.type = type;
      }
      const modal = this.$gjCreate("gj-info-modal", {
        props: {
          title: "操作确认",
          content: `确认操作自动规则，是否继续？`,
        },
        on: {
          cancel: () => {
            modal.$gjDestroy();
          },
          confirm: () => {
            modal.$gjDestroy();
            callback();
          },
        },
      });
      const callback = async () => {
        // 注意 此处是DTO type
        // templateCreateDTO.expressionDTO.type = type;
        const sameData = await querySameRule({
          objectPrimaryId: this.$route.query.objectPrimaryId,
          marketId: this.extra.marketId,
          applyObjectAdsType: this.extra.applyObjectAdsType,
          executeObjectAdsType:
            templateCreateDTO.expressionDTO.executeObjectAdsType,
          strategyType: templateCreateDTO.expressionDTO.strategyType,
          applyObjectIds: [this.extra.campaignId],
        });

        const save = async () => {
          if (this.$route.query.type === "edit") {
            const params = {
              id: this.$route.query.objectPrimaryId,
              marketId: this.extra.marketId,
            };
            if (!this.template) {
              // this.template为null表示是模板进来并选择为了非模板
              params.templateCreateDTO = templateCreateDTO;
            } else {
              if (this.templateType === "rule") {
                params.templateUpdateDTO = templateCreateDTO;
              } else {
                params.templateId = this.template;
              }
            }
            batchRule([params]).then((res) => {
              this.$message.success(res.msg);
              this.handleCancel("1", type === "template" ? "Refresh" : "");
            });
          }

          if (this.$route.query.type === "add") {
            // 首先区分是走模板还是走新增
            const params = {
              objectList: [this.extra],
            };
            if (!this.template) {
              // 新增
              params.templateCreateDTO = await this.getParams();
              if (!params.templateCreateDTO) {
                return;
              }
              params.templateCreateDTO.type = type;
            } else {
              // 模板
              params.templateId = this.template;
            }
            autoRuleObjectData(params).then((res) => {
              this.$message.success(res.msg);
              this.handleCancel("1", type === "template" ? "Refresh" : "");
            });
          }
        };

        if (sameData.length > 0) {
          const modal = this.$gjCreate(affirmModal, {
            props: {
              sameData: sameData[0].ruleDetails.map((item) => {
                item.executeObjectAdsType =
                  objectAdsType[
                    item.templateDetailVO?.expressionVO.executeObjectAdsType
                  ];
                item.name = item.templateDetailVO.name;
                return item;
              }),
            },
            on: {
              cancel: () => modal.$gjDestroy(),
              confirm: () => {
                save();
                modal.$gjDestroy();
              },
            },
          });
        } else {
          save();
        }
      };
    },

    // 单独调整
    handleSingle() {
      const data = this.templateOption.filter(
        (item) => item.text === "不使用模板"
      )[0];
      // 首先将当前的type由 template改为rule
      this.templateType = data.type;
      // 切换后
      this.template = data.id;
    },
  },
};
</script>

<style lang="scss">
.ad-autocomplete-input {
  .el-autocomplete-suggestion__list li {
    font-size: 12px !important;
  }
}
</style>
<style lang="scss" scoped>
.rule-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 12px;
  // &/deep/.el-form-item {
  //   margin-bottom: 20px;
  // }
  .rule-main {
    flex: 1;
    overflow: auto;
    padding: 16px;
    /deep/ .el-input.is-disabled {
      .el-input__inner {
        background: #e4e5e6;
        border: 1px solid #d8dadd;
      }
    }
  }
  .rule-footer {
    height: 48px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);
  }
}
.flex-item {
  display: flex;
  .flex_1 {
    flex: 1.4;
  }
  .flex_2 {
    flex: 2;
  }
}
.rule-setting {
  display: flex;
  margin-top: 20px;
}
.rule-icons {
  width: 48px;
  margin-left: 24px;
  display: flex;
  align-items: center;
  .rule-icon {
    font-size: 16px;
    border: none;
    padding: 0;
    color: #666666;
    height: 16px;
  }
  .rule-icon + .rule-icon {
    margin-left: 16px;
  }
}
.rule-text-bg {
  width: 44px;
  .rule-text {
    color: #666666;
    display: inline-block;
    padding: 0 10px;
    background: #eeeff0;
  }
}
.margin12 + .margin12 {
  margin-left: 12px;
}
.condition-bg {
  width: 906px;
  box-sizing: border-box;
  background: #f6f8fb;
  border-radius: 4px;
  padding: 16px 12px;
}
.condition {
  display: flex;
}
.condition + .condition {
  margin-top: 18px;
}
.rule-description {
  margin-left: 24px;
  max-width: 400px;
  min-width: 272px;
  max-height: 352px;
  background: #f6f8fb;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 8px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  .rule-description-text {
    flex: 1;
    overflow: auto;
    background: #ffffff;
    border-radius: 4px;
    padding: 12px;
    color: #666666;
    line-height: 18px;
    .margintop20 + .margintop20 {
      margin-top: 14px;
    }
  }
}
.error-excursion {
  &/deep/.el-form-item__error {
    padding-left: 10px;
  }
}
.error-input18 {
  &/deep/.el-form-item__error {
    padding-left: 18px;
  }
}
.error-input31 {
  &/deep/.el-form-item__error {
    padding-left: 31px;
  }
}
.handle-content {
  display: flex;
  flex-wrap: wrap;
  width: 900px;
  margin-bottom: -12px;
  .handle-item {
    margin-right: 12px;
    margin-bottom: 12px;
  }
}
.error-padding {
  &/deep/.el-form-item__error {
    padding-left: 84px;
  }
}
.autocomplete-input {
  &/deep/.el-autocomplete {
    .el-input__inner {
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }
  }
}

.base-info {
  display: flex;
  flex-wrap: wrap;
  .flex_100 {
    width: 100%;
  }
  .flex_50 {
    width: 50%;
  }
}
.gj-help {
  /deep/ .gj-help--icon {
    color: #999999;
  }
}
.alert-content {
  margin-bottom: 20px;
  /deep/ .el-alert {
    // border: none;
    // background: none;
    // padding: 0 0 12px 20px;
    width: 996px;
  }
}
</style>
